import React, { useEffect, useState } from "react";

function Health() {
  const [apiStatus, setApiStatus] = useState("checking");
  const [apiUptime, setApiUptime] = useState(null);

 useEffect(() => {
  const checkHealth = async () => {
    try {
      const API_BASE = process.env.REACT_APP_API_BASE || "/api";
      const res = await fetch(`${API_BASE}/health`);

      const raw = await res.text(); // read first, parse if possible
      let data = null;
      try {
        data = raw ? JSON.parse(raw) : null;
      } catch {
        // non-json response (html/text)
      }

      if (res.ok) {
        setApiStatus("healthy");
        setApiUptime(data?.uptime ?? null);
      } else {
        // show you EXACTLY what's wrong
        setApiStatus(`unhealthy (${res.status})`);
        console.log("HEALTH non-2xx:", {
          status: res.status,
          statusText: res.statusText,
          body: data ?? raw,
        });
      }
    } catch (error) {
      setApiStatus("error");
      console.log("HEALTH fetch error:", error);
    }
  };

  checkHealth();
}, []);


  const statusColor = {
    checking: "#fbbf24",
    healthy: "#10b981",
    unhealthy: "#ef4444",
    error: "#ef4444",
  };

  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: "#0a0e1a",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      <div style={{
        textAlign: "center",
        padding: "2rem"
      }}>
        <div style={{
          width: "80px",
          height: "80px",
          margin: "0 auto 1.5rem",
          borderRadius: "50%",
          backgroundColor: statusColor[apiStatus],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "2rem",
          animation: apiStatus === "checking" ? "pulse 2s infinite" : "none"
        }}>
          {apiStatus === "healthy" && ""}
          {apiStatus === "checking" && "..."}
          {(apiStatus === "unhealthy" || apiStatus === "error") && ""}
        </div>

        <h1 style={{
          fontSize: "2rem",
          margin: "0 0 0.5rem",
          fontWeight: "600"
        }}>
          System Health
        </h1>

        <p style={{
          fontSize: "1.125rem",
          margin: "0 0 1.5rem",
          color: statusColor[apiStatus],
          textTransform: "capitalize"
        }}>
          Status: {apiStatus}
        </p>

        {apiUptime !== null && (
          <p style={{
            fontSize: "0.875rem",
            color: "#9ca3af",
            margin: 0
          }}>
            Uptime: {Math.floor(apiUptime / 60)} minutes
          </p>
        )}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}

export default Health;
